import { render, staticRenderFns } from "./Login_sms.vue?vue&type=template&id=bcd5824e"
import script from "./Login_sms.vue?vue&type=script&lang=js"
export * from "./Login_sms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports